import React from 'react'

const GetPageName = () => {

const page =    JSON.parse(sessionStorage.getItem("page"))||null;
  return page?page.toLowerCase():null
}

export default GetPageName